import {Component, OnInit, ViewChild} from "@angular/core";
import {MatTabChangeEvent} from "@angular/material/tabs";

import {PageService} from "src/app/shared/layout/services/page.service";
import {AssociacaoGerenciadorComponent} from "../associacao-gerenciador/associacao-gerenciador/associacao-gerenciador.component";
import {AssociacaoStepperComponent} from "../associacao-stepper/associacao-stepper.component";
import {TipoUpload} from "../../shared/importacao-lote/tipo-upload";
import {ImportacaoLoteComponent} from "../../shared/importacao-lote/importacao-lote.component";
import {Exporter, XLSXExporter} from "../../shared/export/export";
import {HttpResponse} from "@angular/common/http";
import {Observable, Subscription} from "rxjs";
import {ImportacaoLoteService} from "../../shared/importacao-lote/importacao-lote.service";
import {ToastService} from "maps-angular-components";
import {AssociacaoService} from "../associacao-stepper/associacao.service";

@Component({
  selector: "app-associacao-tab",
  templateUrl: "./associacao-tab.component.html",
  styleUrls: ["./associacao-tab.component.scss"],
})
export class AssociacaoTabComponent implements OnInit {
  @ViewChild("associacaoStepper", {static: false})
  associacaoStepper: AssociacaoStepperComponent;

  @ViewChild("associacaoGerenciador", {static: false})
  associacaoGerenciador: AssociacaoGerenciadorComponent;
  readonly  tipo: TipoUpload = TipoUpload.ASSOCIACAO;

  @ViewChild("associacaoImportacaoLote", {static: false}) associacaoImportacaoLote: ImportacaoLoteComponent;
  private readonly subscriptions = new Subscription();

  constructor(private page: PageService,
              private service: AssociacaoService,
              private messageService: ToastService) {
  }

  ngOnInit() {
    this.page.defineTitle("ASSOCIAÇÃO");
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  tabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 0) {
      this.associacaoStepper.limpar();
    } else if ($event.index === 2) {
      this.associacaoGerenciador.limpar();
    }
  }

  downloadModelo(){
    const exporter = new XLSXExporter();
    this.doExportPage(this.service.downloadModelo(), exporter);
  }

  doExportPage(observableData: Observable<HttpResponse<Blob>>, exporter: Exporter) {
    this.subscriptions.add(observableData.subscribe(
        (data: HttpResponse<Blob>) => exporter.save(data),
        err => this.messageService.erro(err.error.message)
    ));
  }
}
